import React, { useEffect } from "react";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

// @material-ui/core components
import Assignment from "@material-ui/icons/Assignment";
import Table from "common/components/Table/Table.jsx";
import loadContent from "core-module/hoc/loadContent";
import { getPackageSpeedRows } from "./PackageSpeedDisplay.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
};

const CurrentPackageCard = (props) => {
  const { classes, passCurrentPackageInfoUp } = props;
  const description = props.getData("description");
  const cap = props.getData("cap");
  const monthly_fee = props.getData("monthly_fee");
  const rate_download = props.getData("rate_download");
  const rate_upload = props.getData("rate_upload");
  const parked = props.getData("parked", "value");
  const no_access = props.getData("no_access", "value");
  const advertised_download_mbps = props.getData(
    "advertised_download_mbps",
    "value"
  );
  const advertised_upload_mbps = props.getData(
    "advertised_upload_mbps",
    "value"
  );

  useEffect(() => {
    passCurrentPackageInfoUp({
      description,
      cap,
      monthly_fee,
      rate_download,
      rate_upload,
      parked,
      no_access,
      advertised_download_mbps,
      advertised_upload_mbps,
    });
  }, [
    passCurrentPackageInfoUp,
    description,
    cap,
    monthly_fee,
    rate_download,
    rate_upload,
    parked,
    no_access,
    advertised_download_mbps,
    advertised_upload_mbps,
  ]);

  const tableData = [
    ["Name", props.getData("description")],
    ["Data cap", /^9+$/.test(cap) ? "Unlimited" : cap + " GB"],
    ["Monthly fee", "$ " + props.getData("monthly_fee")],
  ];

  getPackageSpeedRows({
    cap,
    rate_download,
    rate_upload,
    parked,
    no_access,
    advertised_download_mbps,
    advertised_upload_mbps,
  }).forEach((speed) => tableData.push([speed.label, speed.value]));

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Current Package</h4>
          </CardHeader>
          <CardBody>
            <Table tableData={tableData} />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(styles)(
  loadContent("user.session/currentbroadband", CurrentPackageCard)
);
